(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    (() => {
    const buttons = document.querySelectorAll('[data-down-arrow-next]');

    buttons.forEach((button) => {
      if (button.dataset.downArrowBound === 'true') return;
      button.dataset.downArrowBound = 'true';

      button.addEventListener('click', () => {
        const currentSection = button.closest('.shopify-section');
        if (!currentSection) return;

        let next = currentSection.nextElementSibling;
        while (next && !next.classList.contains('shopify-section')) {
          next = next.nextElementSibling;
        }
        if (!next) return;

        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__textBlockExpandInit) return;
    window.__textBlockExpandInit = true;

    const updateTruncatedState = (wrapper) => {
      if (!wrapper.classList.contains('text-block-wrapper--collapsible') || wrapper.classList.contains('is-expanded')) {
        return;
      }

      const textBlock = wrapper.querySelector('.text-block');
      if (!textBlock) return;

      wrapper.classList.toggle('is-truncated-false', textBlock.scrollHeight <= textBlock.clientHeight + 1);
    };

    document.querySelectorAll('.text-block-wrapper--collapsible').forEach(updateTruncatedState);

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-text-block-toggle]');
      if (!button) return;

      const wrapper = button.closest('.text-block-wrapper--collapsible');
      if (!wrapper) return;

      const isExpanded = wrapper.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(isExpanded));
    });

    window.addEventListener('resize', () => {
      document.querySelectorAll('.text-block-wrapper--collapsible:not(.is-expanded)').forEach(updateTruncatedState);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    class VideoExternalPoster extends HTMLElement {
    connectedCallback() {
      const media = this.closest('deferred-media');
      if (!media || this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      const reveal = () => {
        media.setAttribute('data-video-ready', '');
      };

      const arm = () => {
        const iframe = media.querySelector(':scope > iframe');
        if (!iframe) return;
        const src = iframe.getAttribute('src') || '';
        if (!/^https?:/i.test(src) || iframe.dataset.posterArmed === 'true') return;
        iframe.dataset.posterArmed = 'true';
        iframe.addEventListener('load', reveal, { once: true });
      };

      arm();
      // Consent tools swap the iframe node and set src later. Watch the media, not one iframe.
      this.observer = new MutationObserver(arm);
      this.observer.observe(media, {
        attributes: true,
        attributeFilter: ['src'],
        childList: true,
        subtree: true,
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.dataset.bound = 'false';
    }
  }

  if (!customElements.get('video-poster')) {
    customElements.define('video-poster', VideoExternalPoster);
  }
  } catch(e) { console.error(e); }
})();

})();
